<template>
  <div class="content_work">
    <div>
      <el-form :inline="true" :model="form" class="demo-form-inline" size="small">
        <el-form-item label="菜单名称">
          <el-input v-model="form.title" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="query()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item>
        <el-form-item>
          <div v-if="queryButn && queryButn.name"
            style="margin-left: 50px;display: flex;align-items: center;flex-wrap: nowrap"
            class="animate__animated animate__backInRight">
            <el-button @click="goClick(queryButn)">
              {{ queryButn.name }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="main">
      <strong>综合管理</strong>
      <el-card style="margin-top: 15px">
        <div v-for="(item, index) in workList" :key="index" style="margin-left: 8px">
          <div v-if="item.show" class="bigTitle">{{ item.name }}</div>
          <div v-if="item.key=='oa'">
            <div v-if="item.show&&sysMenu" style="width:100%;text-align:center;font-size:18px">系统设置</div>
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden&&items.wk=='sys'" class="btnItem"
                    :style="{width : '23%', display : items.show}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
            <div v-if="item.show&&lcMenu" style="width:100%;text-align:center;font-size:18px">在线办公</div>
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden&&items.wk=='lc'" class="btnItem"
                    :style="{width : '23%', display : items.show}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
            <div v-if="item.show&&tjMenu" style="width:100%;text-align:center;font-size:18px">统计分析</div>
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden&&items.wk=='tj'" class="btnItem"
                    :style="{width : '23%', display : items.show}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
            <div v-if="item.show&&xxMenu" style="width:100%;text-align:center;font-size:18px">信息管理</div>
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden&&items.wk=='xx'" class="btnItem"
                    :style="{width : '23%', display : items.show}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
            <div v-if="item.show&&xzMenu" style="width:100%;text-align:center;font-size:18px">行政业务流程</div>
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden&&items.wk=='xz'" class="btnItem"
                    :style="{width : '23%', display : items.show}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
            <div v-if="item.show&&ghMenu" style="width:100%;text-align:center;font-size:18px">工会业务流程</div>
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden&&items.wk=='gh'" class="btnItem"
                    :style="{width : '23%', display : items.show}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
          </div>
          <div v-if="item.key!='oa'">
            <div style="margin-left: 30px;">
              <span v-for="(items, i) in item.modelList" :key="i">
                <!-- <el-button v-if="!items.hidden" style="width: 23%"
                  :style="items.key === 1 ? style : undefined" @click="go(item.UrlList, items.path, items)">
                  {{ items.name }}
                </el-button> -->
                <el-tooltip :ref="'button' + index + i " class="item" effect="dark" :content="items.name" placement="top">
                  <el-button  v-if="!items.hidden" class="btnItem"
                    :style="{width : '23%', display : (item.key=='oa'?items.show:'inline')}" @click="go(item.UrlList, items.path, items)" >
                    {{ items.name }}
                  </el-button>
                </el-tooltip>
              </span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>

import { Message } from 'element-ui'
import { checkMenu, checkHyzyMenu } from '../../api/home'
import { getMenus } from '../../api/userMenus'
export default {
  name: 'Homepage',
  props: {
    floatStatus: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      xxMenu: true,
      xzMenu: true,
      ghMenu: true,
      sysMenu: true,
      lcMenu: true,
      tjMenu: true,
      form: {
        title: ''
      },
      menuList: [
        { name: '人员入职', num: 1 },
        { name: '离职申请', num: 1 },
        { name: '请假申请', num: 1 }
      ],
      workList: [
        {
          key: 'oa',
          name: '瀚洋oa',
          show: false,
          UrlList: {
            testUrl: 'http://58.34.191.202:8884/hyoa/a/portal/redirect',
            url: 'https://app.hanyangtelecom.com/hanyang-oa/a/portal/redirect' // 正式环境地址
          },
          modelList: [
            { name: '用户管理', path: '/a/sys/user/index', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '机构管理', path: '/a/sys/office/', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '区域管理', path: '/a/sys/area/', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '分管副总管理', path: '/a/deputygeneral/deputyGeneral/list', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '菜单管理', path: '/a/sys/menu/', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '角色管理', path: '/a/sys/role/', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '字典管理', path: '/a/sys/dict/', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: 'OA通知', path: '/a/info/hyOaNotify/list', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '快捷栏管理', path: '/a/sys/shortcutBar/', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '日志查询', path: '/a/sys/log', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '连接池监视', path: '/druid', num: 0, key: 'oa', show: 'none', wk: 'sys' },
            { name: '流程管理', path: '/a/act/process', num: 0, key: 'oa', show: 'none', wk: 'lc' },
            { name: '模型管理', path: '/a/act/model', num: 0, key: 'oa', show: 'none', wk: 'lc' },
            { name: '人员统计', path: '/a/statistic/personReset/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '合同统计', path: '/a/statistic/contractStats/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '资产统计', path: '/a/statistic/faStats/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '人力成本统计', path: '/a/statistic/personCost/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '台账', path: '/a/statistic/personCost/bill', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '预算汇总列表', path: '/a/summary/hyBudgetSummary/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '预算统计', path: '/a/statistic/budgetStats/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '预算统计表(部门统计)', path: '/a/statistic/budgetStats/getlist', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '部门预算统计', path: '/a/projectbudget/hyProjectBudget/list', num: 0, key: 'oa', show: 'none', wk: 'tj' },
            { name: '合同管理', path: '/a/info/hyBusinessContract/list', num: 0, key: 'oa', show: 'none', wk: 'xx' },
            { name: '资产管理', path: '/a/info/hyFa/list', num: 0, key: 'oa', show: 'none', wk: 'xx' },
            { name: '采购业务', path: '/a/bus/hyBusCg/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '用印信申请', path: '/a/seal/hySeal/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '委外申请流程', path: '/a/outsourcing/hyOutsourcing/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '证照流程申请', path: '/a/certificate/hyCertificate/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '出差审批流程', path: '/a/approval/hySpecialApproval/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '专项费用审批流程', path: '/a/cost/hySpecialExpenses/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '专项费用报销申请流程', path: '/a/expensesreimbursement/hySpecialExpensesReimbursement/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '合同申请流程', path: '/a/contract/hyContract/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '差旅费报销申请流程', path: '/a/travel/hyTravelExpense/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '公司发文申请流程', path: '/a/write/hyCompanyWriting/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '固定资产报废申请', path: '/a/scrap/hyScrap/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '员工指南发布', path: '/a/staffguide/hyStaffGuide/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '料账单业务', path: '/a/lzd/hyBusLzd/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '财务报销申请流程', path: '/a/reimbursement/hyReimbursement/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '固定资产调拨', path: '/a/transfer/hyTransfer/list', num: 0, key: 'oa', show: 'none', wk: 'xz' },
            { name: '专项活动费用申请(公司工会)', path: '/a/activity/hySpecialActivity/list?op=a', num: 0, key: 'oa', show: 'none', wk: 'gh' },
            { name: '帮困救助金会员慰问金申请流程', path: '/a/help/hyHelp/list', num: 0, key: 'oa', show: 'none', wk: 'gh' },
            { name: '帮困救助金申请流程', path: '/a/needy/hyHelpNeedy/list', num: 0, key: 'oa', show: 'none', wk: 'gh' },
            { name: '专项活动费用申请(台室)', path: '/a/activity/hySpecialActivity/list?op=b', num: 0, key: 'oa', show: 'none', wk: 'gh' },
            { name: '公司工会活动报销申请', path: '/a/trade/hyReimbursementActivities/list?type=a', num: 0, key: 'oa', show: 'none', wk: 'gh' },
            { name: '台室工会活动报销申请', path: '/a/trade/hyReimbursementActivities/list?type=b', num: 0, key: 'oa', show: 'none', wk: 'gh' }
          ]
        },
        {
          key: 'zy',
          name: '瀚洋之音',
          show: false,
          UrlList: {
            // https://app.hanyangtelecom.com
            testUrl: 'http://58.34.191.202:8000/wechat/outside/redirect',
            url: 'https://app.hanyangtelecom.com/wechat/outside/redirect' // 正式环境地址
          },
          modelList: [
            { name: '投票管理', path: '/vote/manager', hidden: true, authority: 'vote:manager:view', num: 0, key: 'zy' },
            { name: '投票记录', path: '/vote/statistics/', hidden: true, authority: 'vote:statistics:view', num: 0, key: 'zy' },
            { name: '福利管理', path: '/welfare/manager', hidden: true, authority: 'welfare:manager:view', num: 0, key: 'zy' },
            { name: '领取记录', path: '/welfare/statistics/', hidden: true, authority: 'welfare:statistics:view', num: 0, key: 'zy' },
            { name: '活动管理', path: '/activity/manager', hidden: true, authority: 'activity:manager:view', num: 0, key: 'zy' },
            {name: '报名记录', path: '/activity/statistics/', hidden: true, authority: 'activity:statistics:view', num: 0, key: 'zy'}
          ]
        },
        {
          key: 'rl',
          name: '智慧人力',
          show: true,
          UrlList: {
            url: 'https://app.hanyangtelecom.com/hr/base/login', // 正式环境地址
            testUrl: 'http://58.34.191.202:8000/hr/base/login'
          },
          modelList: [
            { name: '组织一览', path: '/view/departments', num: 0, key: 'rl' },
            { name: '岗位一览', path: '/view/posts', num: 0, key: 'rl' },
            { name: '个人积分', path: '/view/personal_staff_points', num: 0, key: 'rl' },
            { name: '个人年假', path: '/view/personal_staff_holiday', num: 0, key: 'rl' },
            { name: '个人薪资一览', path: '/salary/view/salary_personal', num: 0, key: 'rl' },
            { name: '个人信息一览', path: '/view/staff_personal', num: 0, key: 'rl' },
            { name: '个人排班信息一览', path: '/view/work_arrange_personal', num: 0, key: 'rl' },
            { name: '班组一览', path: '/view/subgroups', num: 0, key: 'rl' },
            { name: '员工一览', path: '/view/staffs', num: 0, key: 'rl' },
            { name: '合同一览', path: '/view/staff_contracts', num: 0, key: 'rl' },
            { name: '员工积分一览', path: '/view/staff_points', num: 0, key: 'rl' },
            { name: '试用期一览', path: '/wf/view/probations', num: 0, key: 'rl' },
            { name: '员工年假一览', path: '/view/staff_holiday', num: 0, key: 'rl' },
            { name: '员工信息修改履历一览', path: '/view/staff_modify_history', num: 0, key: 'rl' },
            { name: '部门考勤一览', path: '/view/work_attendances_department', num: 0, key: 'rl' },
            { name: '所有考勤一览', path: '/view/work_attendances', num: 0, key: 'rl' },
            { name: '异常考勤一览', path: '/view/analysis_result', num: 0, key: 'rl' },
            { name: '薪资模板一', path: '/salary/view/salary_distribute_details_1', num: 0, key: 'rl' },
            { name: '薪资模板二', path: '/salary/view/salary_distribute_details_2', num: 0, key: 'rl' },
            { name: '我的申请', path: '/wf/view/applies', num: 0, key: 'rl' },
            { name: '我的审批', path: '/wf/view/approves', num: 0, key: 'rl' },
            { name: '审批结果', path: '/wf/view/approved', num: 0, key: 'rl' },
            { name: '报表一览', path: '/view/report_list', num: 0, key: 'rl' },
            { name: '绩效一览', path: '/view/staff_performances', num: 0, key: 'rl' },
            { name: '六项扣除一览', path: '/view/staff_tax_deductions', num: 0, key: 'rl' },
            { name: '六项扣除申报', path: '/view/staff_tax_deduction/self', num: 0, key: 'rl' }
          ]
        }
      ],
      queryButn: {},
      commonList: []
    }
  },
  created () {
    this.checkMenu()
    checkHyzyMenu().then((res) => {
      if (res.code === 200) {
        this.workList[1].modelList.forEach(item => {
          if (res.data.includes(item.authority)) {
            item.hidden = false
            this.workList[1].show = true
          }
        })
      }
    })
    if (JSON.parse(localStorage.getItem('work')) === null) {
      this.commonList.push({ name: '请假申请', path: '/a/bus/hyBusQj/list', num: 0, key: 'oa' })
      localStorage.setItem('work', JSON.stringify(this.workList))
    } else {
      this.commonList = [{ name: '请假申请', path: '/a/bus/hyBusQj/list', num: 0, key: 'oa' }]
      const newList = JSON.parse(localStorage.getItem('work'))
      newList.filter(item => {
        item.modelList.filter(items => {
          if (items.num > 0) {
            this.commonList.push(items)
            this.commonList.sort(function (a, b) {
              return b.num - a.num
            })
          }
        })
      })
    }
    const that = this
    var query = {
      token: JSON.parse(localStorage.getItem('Authorization')).val
    }
    var xxCount = 0
    var xzCount = 0
    var ghCount = 0
    var sysCount = 0
    var lcCount = 0
    var tjCount = 0
    // 获取OA菜单
    getMenus(query).then(res => {
      if (res.result === 'success') {
        that.$data.workList.filter(item => {
          item.modelList.filter(items => {
            if (res.data.includes(items.name)) {
              items.show = 'inline'
              this.workList[0].show = true
              if (items.wk === 'xx') {
                xxCount++
              }
              if (items.wk === 'xz') {
                xzCount++
              }
              if (items.wk === 'gh') {
                ghCount++
              }
              if (items.wk === 'sys') {
                sysCount++
              }
              if (items.wk === 'lc') {
                lcCount++
              }
              if (items.wk === 'tj') {
                tjCount++
              }
            }
          })
          if (xxCount === 0) {
            this.xxMenu = false
          }
          if (xzCount === 0) {
            this.xzMenu = false
          }
          if (ghCount === 0) {
            this.ghMenu = false
          }
          if (sysCount === 0) {
            this.sysMenu = false
          }
          if (lcCount === 0) {
            this.lcMenu = false
          }
          if (tjCount === 0) {
            this.tjMenu = false
          }
        })
      } else {
        console.log('getMenus')
        this.$router.go(-1)
        this.$router.push('/')
      }
    })
  },
  methods: {
    checkMenu () {
      checkMenu().then(res => {
        if (res.success && res.data) {
          let arr = [
            { name: '用户管理', path: '/system/user', num: 0, key: 'zy' },
            { name: '角色管理', path: '/system/role', num: 0, key: 'zy' },
            { name: '部门管理', path: '/system/dept', num: 0, key: 'zy' },
            { name: '岗位管理', path: '/system/post', num: 0, key: 'zy' },
            { name: '字典管理', path: '/system/dict', num: 0, key: 'zy' },
            { name: '在线用户', path: '/monitor/online', num: 0, key: 'zy' }
          ]
          this.workList[1].modelList = this.workList[1].modelList.concat(arr)
          this.workList[1].show = true
        }
        if (res.code === 400) {
          console.log('getMenus')
          this.$router.go(-1)
          this.$router.push('/')
        }
      })
    },
    query () {
      this.queryButn = {}
      this.workList.filter(item => {
        item.modelList.filter(items => {
          if (this.form.title === items.name) {
            this.queryButn = items
          }
        })
      })
    },
    go (url, path, val) {
      console.log(url)
      console.log(path)
      console.log(val)
      if (val.key === 'oa' || val.key === 'rl' || val.key === 'zy') {
        const newList = JSON.parse(localStorage.getItem('work'))
        newList.filter(item => {
          item.modelList.filter(items => {
            if (val.name === items.name) {
              items.num = items.num + 1
            }
          })
        })
        localStorage.setItem('work', JSON.stringify(newList))
        this.$router.push({
          path: '/system',
          query: {
            url: url,
            path: path
          }
        })
      } else {
        Message({
          message: '暂未开通服务',
          duration: 2 * 1000
        })
      }
    },
    common (item) {
      if (item) {
        for (const i in this.workList) {
          if (this.workList[i].key === item.key) {
            this.$router.push({
              path: '/system',
              query: {
                url: this.workList[i].UrlList,
                path: item.path
              }
            })
          }
        }
      }
    },
    reset () {
      this.form.title = ''
      this.queryButn = {}
    },
    goClick (item) {
      if (item) {
        for (const i in this.workList) {
          if (this.workList[i].key === item.key) {
            this.$router.push({
              path: '/system',
              query: {
                url: this.workList[i].UrlList,
                path: item.path
              }
            })
          }
        }
      }
    }
  }
}
</script>
<style  scoped>
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  /* background-color: #8c8c8c; */
  background-color: rgba(0, 0, 0, 0.25);
}

::-webkit-scrollbar-track {
  background-color: #f6f6f6;
}

::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  border: 0;
}

.content_work {
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
}

.content_work .top {
  display: flex;
  flex-wrap: nowrap;
  height: 80px;
}

.content_work .top .often_title {
  height: 80px;
  margin-top: 11px;
  width: 30px;
  background-color: #f0f0f0;
  padding: 18px 6px;
  box-sizing: border-box;
  border-radius: 3px;
  margin-right: 10px;
}

.content_work .top .often {
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.content_work .main {
  margin-top: 30px;
}

.content_work .main .el-button {
  margin: 10px 8px;
}

.bgColor {
  background-color: powderblue;
}
.bigTitle{
  width: 100%;
  height: 40px;
  background-color: #f0f0f0;
  line-height: 40px;
  font-weight: 700;
  border-radius: 2px;
  padding-left: 10px;
  box-sizing: border-box;
}

.btnItem{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Work.vue